/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, InputLabel, MenuItem, LinearProgress, CircularProgress, Switch, Radio, Chip, TextField, Collapse } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { colors, fonts } from '../../../utils';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { setAllDocuments } from '../../../redux/slices/shareholderRights/shareholderRights';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import { setAllCourses, setAllCoursesCategoriesList, setAllCoursesList, setAllQuizzes } from '../../../redux/slices/shareholderEducation/shareholderEducation';
import Editor from 'react-simple-wysiwyg';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import Select from 'react-select';


const Quizzes = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { quizzes, coursesList } = useSelector((state) => state.shareHolderEducation);

	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);

	const [courseID, setCourseID] = useState(null);
	const [answersFields, setAnswersFields] = useState([
		{ answer_id: 1, text: '', is_correct: false }
	]);

	const [isPaid, setIsPaid] = useState(false);

	const [formData, setFormData] = useState({
		question: '',
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [filters, setFilters] = useState({
		search: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getData(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		setCourseID(null);
		getData(currentParams.limit, 1, clearedFilters);
	};

	const handleCloseModal = () => {
		setFormData({ question: '' });
		setAnswersFields([{ answer_id: 1, text: '', is_correct: false }]);
		setCourseID(null)
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleAddField = () => {
		const newAnswer = {
			answer_id: answersFields.length + 1,
			text: '',
			is_correct: false
		};
		setAnswersFields([...answersFields, newAnswer]);
	};

	// Function to handle changes in input fields
	// const handleInputChange = (index, event) => {
	// 	const newInputFields = [...answersFields];
	// 	newInputFields[index].text = event.target.value;
	// 	setAnswersFields(newInputFields);
	// };
	const handleInputChange = (index, event) => {
		const updatedAnswers = answersFields?.map((answer, i) =>
			i === index ? { ...answer, text: event.target.value } : answer
		);
		setAnswersFields(updatedAnswers);
	};

	const handleCorrectAnswerChange = (index) => {
		const newAnswers = answersFields?.map((answer, i) => ({
			...answer,
			is_correct: i === index ? true : false
		}));
		setAnswersFields(newAnswers);
	};

	const getData = async (limit, page, filterParams = filters) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.shareHolderEducation?.fetchQuiz,
				{
					"status": filterParams.status || "all",
					"limit": limit || 10,
					"page": page || 1,
					"course_id": courseID || null,
					"search": filterParams.search || null,
					"date_from": filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
					"date_to": filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,
				}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllQuizzes(
							response?.data?.data?.quizzes?.quizzes?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								question: d?.question,
								course_id: d?.course_id,
								dt: d?.dt,
								is_enabled: d?.is_enabled,
								answers: d?.answers,
								creator_name: d?.creator_name,
								creator_id: d?.creator_id,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.quizzes?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});
		} catch (err) {
			// setErrMsg('Login Failed');
			// setDisabledBtn(false);
		}
	};

	const getAllCourseList = async () => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.shareHolderEducation?.fetchCourse,
				{
					"status": "all", //all/true/false
					"limit": 100,
					"page": 1
				}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllCoursesList(
							response?.data?.data?.courses?.courses?.map((d, index) => ({
								id: d?.id,
								description: d?.module,
							})
							),
						),
					);
					setIsLoading(false)

				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};

	const handleCreateModal = () => {
		setOpenModal(true)
		setIsEditing(false);
	};
	const handleEditModal = (val) => {
		const { id, course_id, question, answers, is_enabled } = val;

		setFormData({
			id,
			course_id,
			question,
			answers,
			is_enabled,

		});
		setAnswersFields(answers)
		setOpenModal(true)
		setIsEditing(true);
	};

	const handleDeleteField = (index) => {
		if (answersFields.length > 1) {
			const updatedAnswers = answersFields.filter((_, i) => i !== index);
			setAnswersFields(updatedAnswers);
		}
	};


	const handleSubmit = async () => {
		setIsLoadingModal(true)

		if (!isEditing) {

			try {

				await Api.post(endPoints?.shareHolderEducation?.createQuiz, {
					...formData,
					creator_id: userId,
					creator_name: fullName,
					answers: answersFields,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Quiz Added Successfully")
						setIsLoadingModal(false)


					})
					.catch((error) => {

					});

			} catch (err) {
			}

		} else {


			try {

				await Api.post(endPoints?.shareHolderEducation?.updateQuiz, {
					...formData,
					creator_id: userId,
					creator_name: fullName,
					answers: answersFields,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Quiz Updated Successfully")
						setIsLoadingModal(false)

					})
					.catch((error) => {

					});

			} catch (err) {
			}
		}
	};

	useEffect(() => {
		getAllCourseList();
	}, [])
	useEffect(() => {
		getData();
	}, [courseID])


	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};

	const handleChangeTableSwitch = async (event, val) => {

		try {

			await Api.post(endPoints?.shareHolderEducation?.deleteQuiz, {
				id: val.id,
				status: event.target.checked,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Quiz Status Updated Successfully")
					getData();

				})
				.catch((error) => {

				});

		} catch (err) {
		}

	};

	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_ids',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_ids}</h4>,
		// },
		{
			title: 'Question',
			field: 'question',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.question}</h4>,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},

	];

	const modeOptions = [{
		id: "online",
		description: "Online"
	}, {
		id: "offline",
		description: "Offline"
	}]

	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Quizzes
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Quick Course Filters */}
							<Box sx={{ mb: 2 }}>
								<Typography sx={{ fontSize: '1.2rem', color: '#666', mb: 1 }}>
									Quick Filters by Course:
								</Typography>
								<Flex gap='0.8rem' fw='wrap'>
									{coursesList?.map((course) => (
										<Chip
											key={course.id}
											label={course.description}
											onClick={() => {
												setCourseID(course.id);
											}}
											color={courseID === course.id ? 'success' : 'default'}
											variant={courseID === course.id ? 'filled' : 'outlined'}
											sx={{ fontSize: '1.1rem', cursor: 'pointer' }}
										/>
									))}
								</Flex>
							</Box>

							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Question'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Status'
									state={filters.status}
									onChange={handleFilterChange}
									options={[
										{ id: 'all', description: 'All' },
										{ id: 'true', description: 'Active' },
										{ id: 'false', description: 'Inactive' },
									]}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							<Flex jc='space-between' ai='center' gap='1rem' mt='1.5rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Quiz" : "Create Quiz"}
						isLoading={isLoadingModal}

					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.question}
									// inputProps={{ maxLength: 150 }}
									onChange={handleChange}
									label='Question'
									name='question'
								/>
							</MarginHandler>
							{answersFields && answersFields?.map((val, index) => (
								<MarginHandler key={index} width='100%'>
									<InputControl
										state={val?.text}
										// inputProps={{ maxLength: 40 }}
										onChange={(event) => handleInputChange(index, event)}
										label={`Answer ${index + 1}`}
										name='answers'
									/>
									<div style={{ display: "flex", justifyContent: "space-between" }}>

										<label>
											<input
												style={{ marginTop: "10px", marginRight: "10px" }}
												type="checkbox"
												checked={val.is_correct}
												onChange={() => handleCorrectAnswerChange(index)}
											/>
											Correct Answer
										</label>
										<button style={{ background: "rgb(5, 117, 230)", color: "white", borderRadius: "2px", padding: "2px 10px", border: "none",cursor:"pointer" }} onClick={() => handleDeleteField(index)}>X</button>
									</div>
								</MarginHandler>

							))}
							<div style={{ display: "flex", justifyContent: "space-between" }} >
								<FilledSelectOption
									label='Select Course'
									state={formData?.course_id}
									onChange={(e) => {
										setFormData({ ...formData, course_id: e.target.value });
									}}
									options={coursesList}
									width='18rem'
									name='type'
								/>
								<ButtonCom btnTitle="Add Input" onClickHandler={handleAddField} />
							</div>


							{/* <Select
								defaultValue={selectedCategories}
								onChange={setSelectedCategories}
								options={quizzesCategoriesList}
								isMulti
								placeholder="Select Categories"
								styles={{
									control: (baseStyles, state) => ({
										...baseStyles,
										// borderColor: state.isFocused ? 'grey' : 'red',
										// marginTop: "15px",
										minHeight: "50px",
										minWidth: "200px",
										// marginBottom: "15px",
										fontSize: "13px"
									}),
								}}
							/> */}






							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										// backgroundColor: colorPrimary,
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.question || !formData.course_id}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "}
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>



				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={quizzes?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Quizzes"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getData(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getData(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}








			</Card>
		</>
	);
};

export default Quizzes;
